import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import { useAppSelector } from 'app/hooks';
import TierInfoCards from 'pages/Dashboard/TierInfoCards';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { getTiersService } from 'services/Tiers.service';
import { TierInterface } from 'store/dashboard/dasboardSlice.interface';
import { UserTierState, setTier, setTiersError, setTiersLoading, tierState } from 'store/tiers/tiersSlice';
import * as S from './mailageInfo.styles';
import { MilageInfoProps } from './mile.interface';

const MilageInfo = ({ className, typeUser }: MilageInfoProps) => {
  const { t, i18n } = useTranslation();
  const isLTR = i18n.dir() === 'ltr';

  const [nextTier, setNextTier] = useState<TierInterface>();

  const userTiers = useAppSelector(UserTierState);
  const tiers = useAppSelector(tierState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userTiers || !tiers) {
      getUserTier();
    }
  }, []);

  const getUserTier = async () => {
    dispatch(setTiersLoading());
    getTiersService()
      .then((res) => {
        dispatch(setTier(res.data));
      })
      .catch((err) => {
        dispatch(setTiersError({ err }));
      });
  };

  useEffect(() => {
    for (let i = 0; i < tiers.length; i++) {
      const tier = tiers[i];
      if (tier.type == typeUser && tier.minMilage > (userTiers?.tierMilage || 0)) {
        setNextTier(tier);

        break;
      }
    }
  }, [tiers, userTiers]);

  if (!userTiers) return null;
  if (!userTiers.id) return null;

  const MaxMilage = Math.max(tiers[tiers.length - 1].minMilage * 1.1, userTiers?.tierMilage);
  const LastTier = tiers[tiers.length - 1];
  const getTierPercentage = (mile: number): number => Math.floor((mile / MaxMilage) * 100);

  return (
    <S.MailageInfo className={`${className}`}>
      <S.MailageInfoMain>
        <S.MailageInfoHead>
          <S.MailageInfoHeadTitle>{t('pages.profile.sections.header.title')}</S.MailageInfoHeadTitle>
        </S.MailageInfoHead>

        <S.MailageInfoMainContainer>
          <S.MailageInfoMainBar>
            <S.MailageInfoMainSpan
              $type={userTiers.Tier.name}
              className={'row ' + (userTiers.Tier.name ? userTiers.Tier.name.toLowerCase() : '')}
              style={{
                width: `calc(${
                  getTierPercentage(userTiers.rewardMilage) < 100 ? getTierPercentage(userTiers.tierMilage) : 95
                }% + 10px)`,
                background: tiers.find(
                  (t) => t.type == typeUser && userTiers.tierMilage >= t.minMilage && userTiers.tierMilage < t.maxMilage
                )?.color,
                // userTiers.tierMilage >= LastTier.minMilage ? LastTier?.color : nextTier?.color,
              }}
            />

            {tiers
              .filter((item) => item.type === typeUser)
              .map((item, index) => (
                <S.MailageInfoMainTier
                  $type={userTiers?.Tier.name}
                  className={`${item.name}`}
                  style={
                    isLTR
                      ? { left: ` calc(${getTierPercentage(item.minMilage)}% - 10px)` }
                      : { right: ` calc(${getTierPercentage(item.minMilage)}% - 10px)` }
                  }
                  key={index}
                >
                  <div className="number fs-xxs fw-b">{item.minMilage}</div>
                  <div className="type fs-xxs fw-b">{item.name}</div>
                  <ArrowDropDownOutlinedIcon />
                </S.MailageInfoMainTier>
              ))}
          </S.MailageInfoMainBar>
        </S.MailageInfoMainContainer>
      </S.MailageInfoMain>
      <TierInfoCards rewardMilage={userTiers.rewardMilage} tierMilage={userTiers.tierMilage} />
    </S.MailageInfo>
  );
};

export default MilageInfo;
